const str = `{HEADER}개인정보처리방침
{HEADER_SUB}㈜비디오몬스터(이하 ‘회사’라 한다.)는 ‘개인정보 보호법’, ‘정보통신망 이용촉진 및 정보보호 등에 관한 법률’을 비롯한 모든 개인정보보호 관련 법률규정을 준수하고 있으며, 회사의 개인정보처리방침을 별도로 제정하고 이를 준수함으로써 이용자의 개인정보를 보호하기 위하여 최선의 노력을 다하고 있습니다.

{BODY_TITLE}제1조 (총칙)
1) ‘개인 정보’란 생존하는 개인에 관한 정보로서 당해 정보에 포함되어 있는 성명(닉네임), 이메일주소 등의 사항에 의하여 당해 개인을 식별할 수 있는 정보(당해 정보만으로는 특정 개인을 식별할 수 없더라도 다른 정보와 용이하게 결합하여 식별할 수 있는 것을 포함한다.)를 말합니다.
2) 회사는 개인정보취급방침을 홈페이지 및 애플리케이션에 공개함으로써 회원님께서 언제나 용이하게 열람할 수 있도록 조치하고 있습니다.
3) 회사는 개인정보취급방침의 지속적인 개선을 위하여 개인정보취급방침을 개정하는데 필요한 절차를 정하고 있으며, 개인정보취급방침을 개정하는 경우 버전번호 등을 부여하여 개정된 사항을 회원님께서 쉽게 구분할 수 있도록 하고 있습니다.

{BODY_TITLE}제2조 (개인정보의 항목 및 수집방법) 
1) 회사는 회원가입, 원활한 고객상담, 유료 서비스 제공을 위해 아래와 같은 개인 정보를 수집하고 있습니다. 만 14세 미만의 경우 회원가입 및 서비스 이용이 제한됩니다.
2) 네이버, 구글, 페이스북 간편 회원 가입 및 로그인 시 해당 매체에 제공하는 정보(공개프로필, 이메일주소, 생년월일, 사진 및 동영상 등)가 수집될 수 있습니다.
3) 수집하는 개인정보의 항목
① 필수 입력 항목
- 성명(닉네임), 회원ID(이메일주소와 동일), 비밀번호, 만14세 이상여부
② 선택 입력 항목
- 성별, 연령대, 주소, 직종, 사용용도, 연락처, 추천인
③ 유료서비스 이용과정에서 수집될 수 있는 정보로 결제과정에서만 이용되며 회사에 일체 기록되지 않습니다.
- 공통: 성명(본명), 이동전화번호
- 신용카드 결제 시: 카드명, 카드번호, 카드 유효기간
- 휴대전화 결제 시: 이동전화번호, 통신사, 생년월일, 결제승인번호 
- 계좌이체 결제 시: 은행명, 계좌번호 
- 상품권 결제 시: 상품권 번호
④ 서비스 이용과정이나 사업처리 과정에서 다음의 정보들이 자동으로 생성되어 수집될 수 있습니다.
- 서비스 이용기록, 접속 로그, 쿠키, 접속IP정보, 결제기록, 이용 정지 기록, 모바일 기기정보(OS/앱버전), 브라우저 정보
4) 수집방법
① 홈페이지, 서면양식, 팩스, 이메일을 통한 회원가입
② 전화, 상담 게시판, 이벤트 응모, 배송 요청

{BODY_TITLE}제3조 (개인정보의 수집에 대한 동의)
1) 회사는 회원님께서 회사의 개인정보취급방침을 확인할 수 있도록 표기하고, 이를 동의한 이후 회원 가입을 할 수 있는 환경을 조성합니다.
2) 회사는 회원 가입시 수집하는 회원의 개인정보와 관련하여 개인정보보호법에 따라 개인정보의 수집항목, 이용목적 등을 고지하고 동의를 받습니다.

{BODY_TITLE}제4조 (개인정보의 수집 및 이용목적)
회사는 다음과 같은 목적을 위하여 개인정보를 수집하고 있으며, 수집하는 개인정보 항목에 따른구체적인 수집목적 및 이용목적은 다음과 같습니다.
1) 회원관리와 관련된 개인정보
① 필수 입력 항목
- 성명(닉네임), 회원ID(이메일주소와 동일), 비밀번호: 서비스 이용에 필요한 본인 식별 절차에 이용
- 만 14세 미만여부: 만 14세 미만 어린이의 경우 회원가입 및 서비스 이용을 제한하기 위하여 필요
- 회원ID(이메일주소와 동일): 고지사항 전달, 본인의사 확인, 불만처리 등 원활한 의사소통 경로의 확보, 새로운 서비스, 이벤트 정보의 안내 
- 메일수신여부(뉴스레터, 결제내역): 업데이트 정보, 이벤트 소식, 결제내역 등의 이메일 수신여부 확인
② 선택 입력 항목
- 성별, 직종, 사용용도, 연락처, 전화번호, 추천인: 회사의 발전방향을 위한 참고용 정보의 확보 
- 연락처, 주소: 이벤트, 경품제공시 참여자의 적합성 확인 및 배송에 대한 정확한 배송지의 확보
2) 회사는 이용자의 기본적인 인권 침해의 우려가 있는 민감한 개인정보(인종 및 민족, 사상 및 신조, 출신지 및 본적지, 정치적 성향 및 범죄기록, 건강상태 및 성생활 등)는 수집하지 않습니다.

{BODY_TITLE}제5조 (개인정보 자동수집장치의 설치/운영 및 거부에 관한 사항)
회사는 회원님의 정보를 수시로 저장하고 찾아내는 쿠키(cookie)를 사용합니다. 쿠키란 비디오몬스터 접속 시 자동으로 고객의 컴퓨터로 전송되는 4KB 미만의 텍스트 파일로서 회원님의 하드디스크에 저장됩니다.
1) 쿠키의 사용목적
회원님의 방문 및 이용형태, 보안접속 여부, 광고를 포함한 최적화된 맞춤형 정보를 제공하기 위해 사용합니다.
2) 쿠키의 설치/운영 및 거부
① 회원님께서는 쿠키에 대한 선택권을 가지고 있습니다. 따라서 회원님께서 사용하시는 웹 브라우저의 옵션을 설정함으로써 모든 쿠키를 허용하거나, 쿠키가 저장될 때마다 확인을 거치거나, 아니면 모든 쿠키의 저장을 거부할 수 있습니다.
② 설정방법 예 (구글 크롬) 
오른쪽 상단 더보기 > 설정 > 개인정보 및 보안 > 쿠키 및 기타 사이트 데이터 
쿠키의 저장을 거부할 경우, 서비스 이용에 어려움이 있을 수 있습니다.

{BODY_TITLE}제6조 (목적 외 사용 및 제3자에 대한 제공 및 공유)
1) 회사는 회원님의 개인정보를 「개인정보의 수집 및 이용목적」에서 고지한 범위 내에서 사용하며, 동 범위를 초과하여 이용하거나 타인 또는 타기업, 기관 등 외부에 공개하지 않습니다. 
2) 아래의 경우에는 예외로 합니다.
① 관계법령에 의하여 수사상의 목적으로 관계기관으로부터의 요구가 있을 경우
② 통계작성, 학술연구나 시장조사를 위하여 특정 개인을 식별할 수 없는 형태로 광고주, 협력사나 연구단체 등에 제공할 경우
③ 기타 관계법령에서 정한 절차에 따른 요청이 있는 경우
④ 예외 사항에서도 관계법령에 의하거나 수사기관의 요청에 의해 정보를 제공하는 경우에도 이를 당사자에게 고지하는 것을 원칙으로 운영하고 있습니다. 법률상의 근거에 의해 부득이하게 고지를 하지 못할 수도 있습니다.
3) 본래의 수집목적 및 이용목적에 반하여 무분별하게 정보가 제공되지 않도록 최대한 노력하겠습니다.
 
{BODY_TITLE}제7조 (개인정보의 취급위탁)
1) 회사는 서비스 향상을 위해서 아래와 같이 개인정보를 위탁하고 있으며, 관계 법령에 따라 위탁계약 시 개인정보가 안전하게 관리될 수 있도록 필요한 사항을 규정하고 있습니다.
2) 회사의 개인정보 위탁처리 기관 및 위탁업무 내용은 아래와 같습니다.
- 수탁업체: Microsoft Azure
- 위탁내용: 서비스 제공을 위한 서버 운영
- 보유 및 이용 기간 : 회원 탈퇴 시 혹은 위탁 계약 종료 시까지
{ADD_LINE}
- 수탁업체 : MongoDB, Inc.
- 위택내용 : 서비스 제공을 위한 Cloud DB 운영
- 보유 및 이용 기간 : 회원 탈퇴 시 혹은 위탁 계약 종료 시까지
{ADD_LINE}
- 수탁업체 : (주)채널코퍼레이션
- 위택내용 : 채널톡 채팅 상담 서비스
- 보유 및 이용 기간 : 회원 탈퇴 시 혹은 위탁 계약 종료 시까지
{ADD_LINE}
- 수탁업체 : (주)아임포트
- 위택내용 : 국내 전자결제
- 보유 및 이용 기간 : 회원 탈퇴 시 혹은 위탁 계약 종료 시까지
{ADD_LINE}
- 수탁업체 : (주)스티비
- 위택내용 : 메일 전송
- 보유 및 이용 기간 : 회원 탈퇴 시 혹은 위탁 계약 종료 시까지
{ADD_LINE}
3) 이용자의 개인정보를 국외에 이전하여 저장하는 수탁업체는 다음과 같습니다.

- 수탁업체(연락처) : Stripe (privacy@stripe.com)
- 이용목적 : 해외 전자결제
- 이전국가 : 미국
- 이전항목 : 회원ID(이메일주소와 동일)
- 이전일시 및 방법 : 전자결제 이용 시점에 네트워크를 통한 전송
- 보유 및 이용 기간 : 회원 탈퇴 시 혹은 위탁 계약 종료시까지

{BODY_TITLE}제8조 (이용자 및 법정대리인의 권리와 그 행사방법)
1) 회원님은 회사에 대해 언제든지 다음 각 호의 개인정보 보호 관련 권리를 행사할 수 있습니다.
① 개인정보 열람 요구
② 오류 등이 있을 경우 정정 요구
③ 삭제 요구
④ 처리정지 요구
2) 제1항에 따른 권리 행사는 홈페이지 로그인 후 우측상단의 나의 동영상 > 계정설정에서 직접 열람 및 정정, 탈퇴요구를 하거나, 이용자 본인의 방문, 개인정보관리책임자 및 담당자에게 서면, 전화 또는 E-mail, Fax로 연락하시면 본인여부 확인 후 지체 없이 조치하겠습니다.
3) 회원님이 개인정보의 오류 등에 대한 정정 또는 삭제를 요구한 경우에는 회사는 정정 또는 삭제를 완료할 때까지 당해 개인정보를 이용하거나 제공하지 않습니다.

{BODY_TITLE}제9조 (개인정보의 파기 및 별도 분리 보관)
회사는 개인정보의 수집 및 이용목적이 달성된 경우 또는 회원이 개인정보 관련 동의를 철회하거나 회원을 탈퇴하는 등 더 이상 개인정보의 처리를 원하지 않는 경우, 해당 개인정보를 아래와 같은 방법으로 지체없이 파기합니다. 단, 관계법령의 준수를 위하여 의무적으로 보관하여야 하는 경우는 법령이 정한 기간 동안 최소한의 정보만을 안전하게 보관합니다.
1) 파기절차
① 이용자가 회원가입 등을 위해 입력한 정보는 목적이 달성된 후 별도의 DB(종이의 경우 별도의 서류)로 옮겨져 내부 방침 및 기타 관련 법령에 의한 정보보호 사유에 따라(보유 및 이용기간 참조) 일정 기간 저장된 후 파기됩니다.
② 별도 DB로 옮겨진 개인정보는 법률에 의한 경우가 아니고서는 보유되는 이외의 목적으로 이용되지 않습니다.
2) 파기방법
① 전자적 파일로 저장된 개인정보는 기록을 재생할 수 없는 기술적 방법을 사용하여 삭제합니다.
② 종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각을 통하여 파기합니다.
3) 별도 분리 보관
① 연속하여 1년 동안 비디오몬스터 서비스를 이용하지 않은 회원(장기 미 이용자)의 개인 정보를 별도 분리 보관합니다.
② 별도 분리 보관된 회원의 정보는 휴면계정으로 전환되며, 휴면계정 전환 후 로그인할 경우 휴면계정이 해제됩니다.
③ 별도 분리 보관된 회원의 정보는 관련 법령에 의하여 일정 기간 보유 후 해당 기간이 종료되면 파기합니다.

{BODY_TITLE}제10조 (개인정보의 보유 및 이용기간)
회원님의 개인정보는 원칙적으로 개인정보의 수집목적 또는 제공받는 목적이 달성되면 파기됩니다. 단, 다음의 정보에 대해서는 아래의 이유로 명시한 기간 동안 보존합니다.
1) 회사 내부 방침에 의한 정보보유 사유
① 부정사용자 기록
- 보존이유: 불량 이용자의 재가입 방지, 명예훼손 등 권리침해 분쟁 및 수사협조
- 보존기간: 1년
{ADD_LINE}
2) 관련 법령에 의한 정보보유 사유
① 계약 또는 청약철회 등에 관한 기록
- 보존이유: 전자상거래 등에서의 소비자보호에 관한 법률
- 보존기간: 5년
{ADD_LINE}
② 대금결제 및 재화 등의 공급에 관한 기록
- 보존이유: 전자상거래 등에서의 소비자보호에 관한 법률
- 보존기간: 5년
{ADD_LINE}
③ 소비자의 불만 또는 분쟁처리에 관한 기록
- 보존이유: 전자상거래 등에서의 소비자보호에 관한 법
- 보존기간: 3년
{ADD_LINE}
④ 방문기록
- 보존이유: 통신비밀보호법
- 보존기간: 3개월

{BODY_TITLE}제11조 (개인정보를 위한 기술 및 관리적 대책)
회사는 회원님의 개인정보보호를 취급함에 있어 개인정보가 분실, 도난, 누출, 변조 또는 훼손되지 않도록 안전성 확보를 위하여 다음과 같은 기술적 대책을 강구하고 있습니다.
1) 개인정보보호를 위한 기술적 대책
① 회원님의 개인정보는 비밀번호에 의해 보호되고 있고 이용자 아이디의 암호는 오직 본인만이 알 수 있으며, 개인정보 확인 및 변경도 비밀번호를 알고 있는 본인에 의해서만 가능합니다.
② 회사는 해킹 등 외부침입에 대비하여 회원님의 개인정보가 유출되는 것을 막기 위해 현재 외부로부터 침입을 차단하는 장치를 이용하여 외부로부터의 공격, 해킹 등을 막고 있습니다. 특히, 이용자의 개인정보를 가지고 있는 서버는 높은 수준의 보안을 유지하고 있습니다.
③ 회사는 만약의 사태에 대비하여 시스템과 데이터를 백업하는 체제를 갖추고 있습니다.
2) 개인정보를 위한 관리적 대책
① 회사는 회원님의 개인정보에 대한 접근권한을 최소한의 인원으로 제한하고 있습니다. 그 최소한의 인원에 해당하는 자는 다음과 같습니다.
- 이용자를 직접 상대로 하여 마케팅 업무를 수행하는 자
- 개인정보관리 책임자 및 담당자 등 개인정보관리 업무를 수행하는 자
- 기타 업무상 개인정보 취급이 불가피한 자.
② 개인정보를 취급하는 직원을 대상으로 새로운 보안 기술 습득 및 개인정보 보호의무 등에 관한 정기적인 사내 교육 및 외부 위탁교육을 실시하고 있습니다.
③ 입사시 전 직원의 보안서약서를 통하여 사람에 의한 정보유출을 사전에 방지하고 개인정보취급방침에 대한 이행사항 및 직원의 준수여부를 감시하기 위한 내부절차를 마련하고 있습니다.
④ 개인정보 관련 취급자의 업무 인수인계는 보안이 유지된 상태에서 철저하게 이뤄지고 있으며 입사 및 퇴사 후 개인정보 사고에 대한 책임을 명확화하고 있습니다.
⑤ 회사는 이용자 개인의 실수나 기본적인 인터넷의 위험성 때문에 일어나는 일들에 대한 책임을 지지 않습니다. 회원 개개인이 본인의 개인정보를 보호하기 위해서 자신의 ID 와 비밀번호를 적절하게 관리하여 여기에 대한 책임을 져야 합니다.
⑥ 그 외 내부 관리자의 실수나 기술관리 상의 사고로 인해 개인정보의 상실, 유출, 변조, 훼손이 유발될 경우 회사는 즉각 회원님께 사실을 알리고 적절한 대책과 보상을 강구할 것입니다.

{BODY_TITLE}제12조 (외부사이트로의 유입)
1) 회사는 회원님께 다른 회사의 웹사이트 또는 자료에 대한 링크를 제공할 수 있습니다. 이 경우 회사는 외부 사이트 및 자료에 대한 아무런 통제권이 없으므로 그로부터 제공받는 서비스나 자료의 유용성에 대한 책임을 질 수 없으며 보증할 수 없습니다.
2) 회사가 포함하고 있는 링크를 클릭(click)하여 타 사이트(site)의 페이지로 옮겨갈 경우 해당 사이트의 개인정보취급방침은 회사와 무관하므로 새로 방문한 사이트의 정책을 확인하시기 바랍니다.

{BODY_TITLE}제13조 (광고성 정보 전송)
1) 회사는 회원님의 명시적인 수신거부 의사에 반하여 영리목적의 광고성 정보를 전송하지 않습니다.
2) 회사는 회원님이 뉴스레터 등 전자우편 전송에 대한 동의를 한 경우 전자우편의 제목란 및 본문란에 다음과 같이 회원님이 쉽게 알아볼 수 있도록 조치합니다.
① 전자우편 제목란: [광고]라는 문구를 제목란에 표시하지 않을 수 있으며 전자우편 본문란의 주요내용을 표시합니다.

{BODY_TITLE}제14조 (고지의 의무)
법령 및 방침에 따른 추가, 삭제 및 정정 시 변경사항 시행 7일 전부터 공지사항을 통해 고지할 것입니다.

{BODY_TITLE}제15조 (개인정보 관리 책임자 및 담당자)
회사는 회원님이 좋은 정보를 안전하게 이용할 수 있도록 최선을 다하고 있습니다. 회원님의 개인정보를 취급하는 책임자 및 담당자는 다음과 같으며 개인정보 관련 문의사항에 신속하고 성실하게 답변해 드리고 있습니다.
개인정보관리책임자
- 성 명: 전동혁
- 소 속: 개인정보보호팀
- 직 위: 대표이사
- 전자우편: support@videomonster.com
- 전화번호: 02-554-6801
{ADD_LINE}
개인정보관리담당자
- 성 명: 이우섭
- 소 속: 개인정보보호팀
- 직 위: 기술책임자
- 전자우편: support@videomonster.com
- 전화번호: 02-554-6801
{ADD_LINE}
기타 개인정보에 관한 신고나 상담이 필요한 경우에는 아래 기관에 문의하시기 바랍니다.
개인정보침해신고센터 (privacy.kisa.or.kr / 국번없이 118)
대검찰청 사이버수사과 (www.spo.go.kr / 국번없이 1301)
경찰청 사이버안전국 (www.ctrc.go.kr / 국번없이 182)

{FOOTER}<부칙>
{FOOTER_SUB}본 정책은 2023년 01월 01일부터 시행합니다.
`

export default str